// extracted by mini-css-extract-plugin
module.exports = {"mobileBottomTabBarContainer":"_1ALYVTOl9C8WzMrpfxdDMZ","tv":"_61etYxXTyirmZetKZNJq8","iconContainer":"_1PywCmiWjEnk1CKhT7MXVZ"};